import { TOfferDataRequirement } from '../../../../types';
import DocumentRequirement from '../../DocumentRequirement/DocumentRequirement';

type TProps = {
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
const ManagementAccounts = ({ isSubmitted, status }: TProps) => {
  return (
    <DocumentRequirement
      title="Current management accounts"
      documentType="management accounts"
      isSubmitted={isSubmitted}
      status={status}
    >
      <p>
        These could be whatever your business uses to aid forecasting, spending
        and budgeting.
      </p>
    </DocumentRequirement>
  );
};

export default ManagementAccounts;
